import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

export const SET_BRAND_ID = '[CONSOLE] SET BRAND ID';
export const SET_COUNTRY_ID = '[CONSOLE] SET COUNTRY ID';
export const SET_GROUP_ID = '[CONSOLE] SET GROUP ID';
export const SET_DATE_START = '[CONSOLE] SET DATE START ';
export const SET_DATE_END = '[CONSOLE] SET DATE END';
export const SET_BOOLEAN_AQUITEM = '[CONSOLE] SET_BOOLEAN_AQUITEM';
export const SET_BOOLEAN_INTRANET = '[CONSOLE] SET_BOOLEAN_INTRANET';
export const SET_ORDER = '[CONSOLE] SET_ORDER';
export const GET_FEEDBACKS = '[CONSOLE] GET_FEEDBACKS';

export function setBrandId(brand_id) {
  return {
    type: SET_BRAND_ID,
    brand_id
  };
}

export function setCountryId(country_id) {
  return {
    type: SET_COUNTRY_ID,
    country_id
  };
}

export function setGroupId(group_id) {
  return {
    type: SET_GROUP_ID,
    group_id
  };
}

export function setDateStart(date_start) {
  return {
    type: SET_DATE_START,
    date_start
  };
}

export function setDateEnd(date_end) {
  return {
    type: SET_DATE_END,
    date_end
  };
}

export function setBooleanAquitem(boolean_aquitem) {
  return {
    type: SET_BOOLEAN_AQUITEM,
    boolean_aquitem
  };
}

export function setBooleanIntranet(boolean_intranet) {
  return {
    type: SET_BOOLEAN_INTRANET,
    boolean_intranet
  };
}

export function setBooleanOrder(boolean_order) {
  return {
    type: SET_ORDER,
    boolean_order
  };
}

export function getFeedbacks() {
  const request = axios.get(`${getCurrentApiUrl()}/feedbacks/dashboard`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_FEEDBACKS,
          feedbacks: response.data
        });
      })
      .catch(err => err);
}
